const updateProvince = (payload) => {
  return {
    type: 'province/update',
    payload
  }
}

export default updateProvince;